import { FC } from 'react';
import ReactFC from 'react-fusioncharts';
import FusionCharts, { ChartObject } from 'fusioncharts';
import Doughnut2D from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import { AssetChartDetails } from '@src/app/store/reducers/assetAllocation/types';
import strings from '@src/app/strings/LocalisedStrings';

interface DoughnutChartProps {
  chartData: AssetChartDetails[];
  width?: string;
  height?: string;
  pieRadius?: string;
}

ReactFC.fcRoot(FusionCharts, Doughnut2D, FusionTheme);

const DoughnutChart: FC<DoughnutChartProps> = ({ chartData, width, height, pieRadius }): JSX.Element => {
  const chartConfig: ChartObject = {
    type: 'doughnut2d',
    width: width || '360',
    height: height || '345',
    dataFormat: 'json',
    dataEmptyMessage: strings.emptyPortfolioDataMessage,
    dataSource: {
      chart: {
        theme: 'fusion',
        pieRadius: pieRadius || '160',
        startingAngle: '90',
        doughnutRadius: '105',
        showpercentvalues: '1',
        animation: true,
        animateClockwise: true,
        radius3D: '5',
        smartLineThickness: '0',
        labelFontSize: '0',
        showLegend: false,
        labelFontColor: '#ffffff',
        bgColor: '#ffffff',
        labelDisplay: '0',
        aligncaptionwithcanvas: '1',
        plottooltext: '<b>$percentValue</b> in <b>$label</b>',
        legendPosition: 'right',
        enableRotation: false,
        enableSlicing: false,
      },
      data: chartData,
    },
  };

  return <ReactFC {...chartConfig} />;
};

export default DoughnutChart;
